/* Global imports. */
import React, {useState} from "react"
import { nanoid } from 'nanoid';
import { useStaticQuery, graphql, Link } from "gatsby"
import { useThemeOptions } from "@src/hooks/useThemeOptions"
import { useSiteMetadata } from "@src/hooks/useSiteMetaData"
import SimpleNavigation from "@components/SimpleNavigation"

import FacebookIcon from "@images/icon--facebook.svg";
import InstagramIcon from "@images/icon--instagram.svg";
import TwitterIcon from "@images/icon--twitter.svg";
import TikTokIcon from "@images/icon--tiktok.png";
import YouTubeIcon from "@images/icon--youtube.png";
import SoundcloudIcon from "@images/icon--soundcloud.png"

import NewsletterHelper from "@components/NewsletterHelper"

function Footer({sliceContext}) {
  const data = useStaticQuery(graphql`
  query FooterQuery {
    allKontentItemNavigationItem(
      filter: {
        system: {
          codename: { eq: "navigation__footer_lists" }
        }
      }
    ) {
      nodes {
        elements {
          linked_item {
            value {
              ... on kontent_item_navigation_item {
                id
                elements {
                  title {
                    value
                  }
                  external_url {
                    value
                  }
                  show_external_url_icon {
                    value {
                      codename
                    }
                  }
                  linked_item {
                    value {
                      ... on kontent_item_template__contributor_list {
                        id
                        elements {
                          url_slug {
                            value
                          }
                          title {
                            value
                          }
                        }
                      }
                      ... on kontent_item_template__article_list{
                        id
                        elements {
                          title {
                            value
                          }
                          url_slug {
                            value
                          }
                        }
                      }
                      ... on kontent_item_navigation_item {
                        id
                        elements {
                          title {
                            value
                          }
                          external_url {
                            value
                          }
                          show_external_url_icon {
                            value {
                              codename
                            }
                          }
                          linked_item {
                            value {
                              ... on kontent_item_navigation_item {
                                id
                                elements {
                                  title {
                                    value
                                  }
                                  external_url {
                                    value
                                  }
                                  show_external_url_icon {
                                    value {
                                      codename
                                    }
                                  }
                                }
                              }
                              ... on kontent_item_template__contributor_list {
                                id
                                elements {
                                  url_slug {
                                    value
                                  }
                                  title {
                                    value
                                  }
                                }
                              }
                              ... on kontent_item_template__article_list{
                                id
                                elements {
                                  title {
                                    value
                                  }
                                  url_slug {
                                    value
                                  }
                                }
                              }
                              ... on kontent_item_template__general {
                                id
                                elements {
                                  url_slug {
                                    value
                                  }
                                  title {
                                    value
                                  }
                                }
                              }
                              ... on kontent_item_imprint {
                                id
                                elements {
                                  url_slug {
                                    value
                                  }
                                  title {
                                    value
                                  }
                                }
                              }
                              ... on kontent_item_template__resources {
                                id
                                elements {
                                  url_slug {
                                    value
                                  }
                                  title {
                                    value
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                      ... on kontent_item_template__general {
                        id
                        elements {
                          url_slug {
                            value
                          }
                          title {
                            value
                          }
                        }
                      }
                      ... on kontent_item_imprint {
                        id
                        elements {
                          url_slug {
                            value
                          }
                          title {
                            value
                          }
                        }
                      }
                      ... on kontent_item_template__resources {
                        id
                        elements {
                          url_slug {
                            value
                          }
                          title {
                            value
                          }
                        }
                      }
                    }
                  }
                }
              }
              ... on kontent_item_template__general {
                id
                elements {
                  url_slug {
                    value
                  }
                  title {
                    value
                  }
                }
              }
              ... on kontent_item_imprint {
                id
                elements {
                  url_slug {
                    value
                  }
                  title {
                    value
                  }
                }
              }
            }
          }
          external_url {
            value
          }
          title {
            value
          }
        }
      }
    }
  }
`)

  const [footerMenuOpen, setFooterMenuOpen] = useState('false')
  const toggleFooter = (i) => footerMenuOpen === i ? setFooterMenuOpen() : setFooterMenuOpen(i)
  const navItems = data && data.allKontentItemNavigationItem && data.allKontentItemNavigationItem.nodes && data.allKontentItemNavigationItem.nodes[0] && data.allKontentItemNavigationItem.nodes[0].elements.linked_item.value
  const { displayFooterEmailSignUp, displayOneTrustFooterButton} = useThemeOptions()
  const { social, useMailChimpFooterNewsletter } = useSiteMetadata()

  return <footer className="relative w-full mt-16 overflow-hidden md:mt-16">
  {(displayFooterEmailSignUp || displayFooterEmailSignUp == undefined) && (
    (useMailChimpFooterNewsletter && useMailChimpFooterNewsletter === true ) ? (
      <div className="container-main">
        <div className="text-black leading-6 text-center font-sans p-6 sm:p-10 w-full border-t border-[#ccc] max-w-[880px] ml-auto mr-auto" id="newsletterform" dangerouslySetInnerHTML={{ __html: sliceContext.htmlMarkup}}></div>
      </div>
    ) :
    ((!sliceContext || !sliceContext.hideNewsletterForm) && !useMailChimpFooterNewsletter ) ? (
      <div className="container-main">
        <div className="text-black leading-6 text-center font-sans p-6 sm:p-10 w-full border-t border-[#ccc] max-w-[880px] ml-auto mr-auto" id="newsletterform">
          <NewsletterHelper newsletterType={sliceContext && sliceContext.formName ? sliceContext.formName : "best_of_pan_macmillan_newsletter__generic"} newsletterLocation="footer" />
        </div>
      </div>
    )  
    : null
  )}
      <section className="bg-[#202020] mb-2 sm:mb-14 pt-4 pb-4 sm:pb-10 sm:pt-10">
        <div className="container-main">
          <div className="grid flex-wrap justify-between grid-cols-12 gap-0 sm:gap-10">
            <div className="w-auto col-span-7"></div>
            <ul className="flex w-auto col-span-12 sm:col-span-5 justify-items-start sm:justify-self-end">
              <li className="max-w-[500px]">
              <ul className="flex items-center">
                <li key="social-1" className="text-white max-w-[150px] sans mr-4">Find us on</li>
                {social.facebook && <li key={nanoid()} className="mr-4 sans max-w-8">
                  <a
                    href={social.facebook}
                    data-social="Facebook"
                    className="js-follow"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="Facebook"
                      title="Facebook"
                      src={FacebookIcon}
                      width="32"
                      height="32"
                      className="optanon-category-C0004"
                    />
                  </a>
                </li>}
                {social.instagram && <li key={nanoid()} className="mr-4 sans max-w-8">
                  <a
                    href={social.instagram}
                    data-social="Instagram"
                    className="js-follow"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="Instagram"
                      title="Instagram"
                      src={InstagramIcon}
                      width="32"
                      height="32"
                      className="optanon-category-C0004"
                    />
                  </a>
                </li>
                }
                {social.twitter && <li key={nanoid()} className="mr-4 sans max-w-8">
                  <a
                    href={social.twitter}
                    data-social="Twitter"
                    className="js-follow"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="X (Twitter)"
                      title="X (Twitter)"
                      src={TwitterIcon}
                      width="18"
                      height="18"
                      className="optanon-category-C0004 flex items-center justify-center bg-black rounded-2xl w-8 h-8 p-2 overflow-visible"
                    />
                  </a>
                </li>
                }
                {social.tiktok && <li key={nanoid()} className="mr-4 sans max-w-8">
                  <a
                    href={social.tiktok}
                    data-social="TikTok"
                    className="js-follow"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="TikTok"
                      title="TikTok"
                      src={TikTokIcon}
                      width="32"
                      height="32"
                      className="optanon-category-C0004"
                    />
                  </a>
                </li>
                }
                {social.soundcloud && <li key={nanoid()} className="mr-4 sans max-w-8">
                  <a
                    href={social.soundcloud}
                    data-social="SoundCloud"
                    className="js-follow"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="SoundCloud"
                      title="SoundCloud"
                      src={SoundcloudIcon}
                      width="32"
                      height="32"
                      className="optanon-category-C0004"
                    />
                  </a>
                </li>
                }
                {social.youtube && <li key={nanoid()} className="mr-4 sans max-w-8">
                  <a
                    href={social.youtube}
                    data-social="YouTube"
                    className="js-follow"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="YouTube"
                      title="YouTube"
                      src={YouTubeIcon}
                      width="32"
                      height="32"
                      className="optanon-category-C0004"
                    />
                  </a>
                </li>
                }
              </ul>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="container-main">
          <div className="flex flex-wrap justify-between sm:flex-nowrap sm:flex sm:justify-between mb-14">
          {navItems && navItems.map((item, i) => {
              const subItems = item && item.elements && item.elements.linked_item && item.elements.linked_item.value
              return (
                <ul key={nanoid()} className={footerMenuOpen === i ? "page-list open" : "page-list sm:max-w-[245px]"}>
                  <li role="menuitem" key={nanoid()}><p className="text-[#202020] mb-6 leading-8 font-sans text-lg sm:text-2xl font-bold cursor-pointer" key={nanoid()} onClick={e => { toggleFooter(i)}} onKeyDown={e => { toggleFooter(i)}}>{item.elements.title.value}</p></li>
                  {subItems && subItems.map((item, i) => {
                    if (item && item.elements && item.elements.url_slug) {
                      return (
                        <li className="w-full" key={nanoid()}>
                          <Link
                            className="no-underline mb-2 text-[#767676] text-base pb-1 font-sans leading-6 inline-block relative transition-all duration-300 ease-linear hover:text-red hover:after:bottom-0 hover:after:h-[2px] hover:after:left-0 hover:after:w-full hover:after:absolute hover:after:bg-red after:transition-all after:duration-300 after:ease hover:after:scale-x-100 after:scale-x-0"
                            to={`/${item.elements.url_slug.value}`}
                          >
                            {item.elements.title.value}
                          </Link>
                        </li>
                      )
                    } else if (item && item.elements && item.elements.external_url) {
                      return ( <li key={nanoid()}>
                        <a href={item.elements.external_url && item.elements.external_url.value} className="mb-2 text-[#767676] text-base pb-1 font-sans leading-6 inline-block items-center gap-2 relative transition-all duration-300 ease-linear hover:text-red hover:after:bottom-0 hover:after:h-[2px] hover:after:left-0 hover:after:w-full hover:after:absolute hover:after:bg-red after:transition-all after:duration-300 after:ease hover:after:scale-x-100 after:scale-x-0 no-underline">
                          {item.elements.title && item.elements.title.value}
                          { item.elements.show_external_url_icon && item.elements.show_external_url_icon.value[0] && item.elements.show_external_url_icon.value[0].codename == "yes" &&
                            <span className="inline-block ml-2 w-3 h-3">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"/></svg>
                            </span>
                          }
                        </a>
                      </li> )
                    } else {
                      return null
                    }
                  })}
                </ul>
              )
            })}
          </div>
      </section>
      <section className="container-main">
        <div className="sm:border-t flex sm:border-[#eee] sm:pb-8 sm:pt-8">
          <div className="flex flex-col items-center w-full md:items-inherit md:flex-row sm:justify-between sm:pt-4 sm:pb-8">
            {
            displayOneTrustFooterButton && <div dangerouslySetInnerHTML={{ __html: '<button id="ot-sdk-btn" class="ot-sdk-show-settings mb-8 sm:mb-0">Cookie Settings</button>' }} />
            }
            <SimpleNavigation />
            
          </div>
        </div>
      </section>
    </footer>
}

export default Footer;
